import React from "react";
import { Navigate } from "react-router-dom";

import Companies from "../companies/Companies";
import CompanyAdmins from "../companyAdmin/Admins";
import FellowAdmins from "../fellowAdmin/fellowAdmins";
import ManageTeamsPage from "./ManageTeamsPage";
import ManageSitesPage from "./ManageSitesPage";

const StandaloneCompanies = () => <Companies />;
const StandaloneCompanyAdmins = () => <CompanyAdmins />;
const StandaloneFellowAdmins = () => <FellowAdmins />;

export const standaloneRoutes = [
  { path: "/standalone/companies", element: <StandaloneCompanies /> },
  { path: "/standalone/company-admins", element: <StandaloneCompanyAdmins /> },
  { path: "/standalone/fellow-admins", element: <StandaloneFellowAdmins /> },
  { path: "/standalone/manage-teams", element: <ManageTeamsPage /> },
  { path: "/standalone/manage-sites", element: <ManageSitesPage /> },
];

export const LegacyStandaloneRedirect = ({ to }) => <Navigate to={to} replace />;

export default standaloneRoutes;
